const bytesFromBase64 = (payload) => {
  try {
    const decoded = globalThis.atob(payload.slice(0, 48));
    return Array.from(decoded, (character) => character.charCodeAt(0));
  } catch {
    return [];
  }
};

export const stockMonogram = (symbol) => {
  const primary = String(symbol || '').toUpperCase().split(/[.\-/]/)[0].replace(/[^A-Z0-9]/g, '');
  return (primary || '—').slice(0, 4);
};

export const normalizeLogoDataUri = (value) => {
  const match = /^data:image\/[a-z0-9.+-]+;base64,([a-z0-9+/=\s]+)$/i.exec(String(value || '').trim());
  if (!match) return null;
  const payload = match[1].replace(/\s/g, '');
  const bytes = bytesFromBase64(payload);
  let mime = null;
  if (bytes.slice(0, 8).join(',') === '137,80,78,71,13,10,26,10') mime = 'image/png';
  else if (bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) mime = 'image/jpeg';
  else if (String.fromCharCode(...bytes.slice(0, 4)) === 'GIF8') mime = 'image/gif';
  else if (
    String.fromCharCode(...bytes.slice(0, 4)) === 'RIFF'
    && String.fromCharCode(...bytes.slice(8, 12)) === 'WEBP'
  ) mime = 'image/webp';
  if (!mime) return null;
  return `data:${mime};base64,${payload}`;
};
